module.exports = __webpack_public_path__ + "516f92b4776f45bf26e9e0295e54b5b3.svg";